const baseURLs = {
  local: "http://localhost:3000/api",
  web: "https://officeapi.kaaryaalaya.com/api",
};

// Socket.IO is served from the same backend, without the /api prefix
// (the socket path itself is namespaced as /api/socket.io).
const notifURLs = {
  local: "http://localhost:3000",
  web: "https://officeapi.kaaryaalaya.com",
};

const environment = process.env.NODE_ENV === "production" ? "web" : "local";

export const getURL = () => baseURLs[environment];

export const getNotifURL = () => notifURLs[environment];

export const getImageURL = (url) => `${getURL()}${url}`;

export default {
  getURL,
  getNotifURL,
  getImageURL,
};
